<script setup lang="ts">
import { useCmsSection } from "@shopware/composables";
import type { CmsSectionSidebar } from "@shopware/composables";
import { getTranslatedProperty } from "@shopware/helpers";
import { computed } from "vue";
import { useCategory } from "#imports";

const props = defineProps<{
  content: CmsSectionSidebar;
}>();
const { getPositionContent } = useCmsSection(props.content);

const sidebarBlocks = getPositionContent("sidebar");
const mainBlocks = getPositionContent("main");
const mobileBehavior = computed(() => props.content.mobileBehavior);
const { category } = useCategory();

const hideMobileFilter = ref(false);
</script>

<template>
  <section class="pt-5 xl:pt-[120px] pb-20 md:pb-24 lg:pb-32 xl:pb-40">
    <div class="cms-section-sidebar container">
      <div class="w-full flex flex-wrap gap-y-10 justify-end">
        <div
          @click="hideMobileFilter = false"
          class="sidebar_overlay bg-cust_gray w-full h-full opacity-30 fixed top-0 left-0 z-50 hidden tablet:block"
          :class="{ 'tablet:hidden': !hideMobileFilter }"
        ></div>
        <div
          class="left-sidebar w-[260px] xxl:w-[293px] lg:block tablet:h-full tablet:fixed tablet:bg-white tablet:pt-5 tablet:top-0 tablet:left-0 tablet:w-[80%] tablet:pr-4"
          :class="{
            'tablet:block  tablet:translate-x-0 tablet:z-[500]':
              hideMobileFilter,
            'tablet:hidden tablet:-translate-x-full tablet:z-0':
              !hideMobileFilter,
          }"
        >
          <div class="relative w-full h-10 md:hidden">
            <button
              type="button"
              class="w-10 h-10 md:hidden absolute -top-2 right-0 bg-skin-body rounded-lg bg-humburger-close bg-no-repeat bg-[center] bg-[length:1rem] border"
              :class="{ hidden: !hideMobileFilter }"
              @click="hideMobileFilter = false"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="tablet:h-full tablet:overflow-y-scroll hide-scrollbar mt-5">
            <CmsGenericBlock
              v-for="cmsBlock in sidebarBlocks"
              :key="cmsBlock.id"
              class="overflow-auto"
              :content="cmsBlock"
            />
          </div>
        </div>
        <div
          class="right-data w-full lg:w-[calc(100%-260px)] xxl:w-[calc(100%-293px)] lg:ps-10 xxl:ps-12 justify-between flex [&>div]:w-full"
        >
          <CmsGenericBlock
            v-for="cmsBlock in mainBlocks"
            :key="cmsBlock.id"
            :content="cmsBlock"
          />
        </div>
      </div>
    </div>

    <div
      class="filter_bar hidden tablet:block w-full text-center p-2.5 shadow-[0px_-1px_15px_-2px_rgba(0,0,0,0.3)] fixed bottom-0 left-0 bg-white z-40 transition-all duration-300 [&.down]:-bottom-20"
    >
      <button
        type="button"
        class="btn btn-filter bg-cust_green p-3 rounded-3xl text-white m-auto min-w-[10rem]"
        @click="hideMobileFilter = !hideMobileFilter"
      >
        <span v-if="!hideMobileFilter" class="mt-1"
          ><i class="fa-solid fa-filter mr-2"></i
          >{{ $t("plubel.listing.filter") }}</span
        >
        <span v-else class="mt-1"
          ><i class="fa-solid fa-times mr-2"></i
          >{{ $t("plubel.listing.close") }}</span
        >
      </button>
    </div>
  </section>
</template>
